import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {
  arrow,
  autoUpdate,
  flip,
  FloatingArrow,
  offset,
  shift,
  useDismiss,
  useFloating,
  useHover,
  useInteractions,
  useRole,
} from '@floating-ui/react';
import {Info} from '@phosphor-icons/react';
import {Fragment, useRef, useState} from 'react';
type InformationTootlipProps = {
  children: React.ReactNode;
  className?: string;
};

export const InformationTootlip: React.FC<InformationTootlipProps> = ({children, className}) => {
  const arrowRef = useRef(null);
  const {hasDarkBg} = useThemeContext();
  const [isOpen, setIsOpen] = useState(false);
  const {refs, floatingStyles, context} = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [
      offset(10),
      flip(),
      shift(),
      arrow({
        element: arrowRef,
      }),
    ],
    placement: 'top',
    whileElementsMounted: autoUpdate,
  });
  const hover = useHover(context, {move: false});
  const dismiss = useDismiss(context);
  const role = useRole(context, {role: 'tooltip'});
  const {getReferenceProps, getFloatingProps} = useInteractions([hover, dismiss, role]);

  return (
    <Fragment>
      <Info
        ref={refs.setReference}
        {...getReferenceProps()}
        className={classNames(
          'h-4 w-4 cursor-pointer',
          hasDarkBg ? 'text-white/50' : 'text-black/50',
          className
        )}
      />
      {isOpen && (
        <div ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
          <FloatingArrow
            ref={arrowRef}
            context={context}
            className={classNames(hasDarkBg ? 'fill-black' : 'fill-white')}
          />
          <p
            className={classNames(
              'rounded-md px-2 py-1 text-sm font-medium',
              hasDarkBg ? 'bg-black text-white/70' : 'bg-white text-black/70'
            )}
          >
            {children}
          </p>
        </div>
      )}
    </Fragment>
  );
};
